import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from './supabaseClient';
import axios from 'axios';

const MAPBOX_TOKEN = "pk.eyJ1IjoieXVraWhpZG8iLCJhIjoiY21jbzdsa2o0MTM1dzJscTF6ZTJjbzBxbyJ9.0oahdC5gR_i8GTyn1zWtwQ";

export default function SignUp({ onAuth }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [address, setAddress] = useState('');
  const [address2, setAddress2] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [addressLoading, setAddressLoading] = useState(false);
  const [deliveryInstructions, setDeliveryInstructions] = useState('');
  const navigate = useNavigate();

  const upsertUser = async (user) => {
    if (!user) return;
    await supabase.from('users').upsert([
      {
        id: user.id,
        email: user.email,
        name,
        address,
        address2,
        phone,
        delivery_instructions: deliveryInstructions,
      }
    ]);
  };

  const handleSignUp = async () => {
    if (!name) {
      setMessage('Name is required.');
      return;
    }
    const { data, error } = await supabase.auth.signUp({ email, password });
    setMessage(error ? error.message : 'Check your email for a confirmation link!');
    if (data?.user) {
      await upsertUser(data.user);
      await supabase.auth.signOut();
      navigate('/confirm-email');
    }
  };

  // Address autocomplete
  const handleAddressChange = async (e) => {
    const value = e.target.value;
    setAddress(value);
    if (!value) {
      setAddressSuggestions([]);
      return;
    }
    setAddressLoading(true);
    try {
      const res = await axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(value)}.json`,
        {
          params: {
            access_token: MAPBOX_TOKEN,
            autocomplete: true,
            country: 'US',
            limit: 5,
          },
        }
      );
      setAddressSuggestions(res.data.features.map(f => f.place_name));
    } catch (err) {
      setAddressSuggestions([]);
    }
    setAddressLoading(false);
  };

  const handleAddressSelect = (suggestion) => {
    setAddress(suggestion);
    setAddressSuggestions([]);
  };

  return (
    <div>
      <h2>Sign Up</h2>
      <div className="form-group">
        <label htmlFor="name">Name</label>
        <input id="name" value={name} onChange={e => setName(e.target.value)} placeholder="Your name" required />
      </div>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input id="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" />
      </div>
      <div className="form-group">
        <label htmlFor="password">Password</label>
        <input id="password" value={password} onChange={e => setPassword(e.target.value)} type="password" placeholder="Password" />
      </div>
      <div className="form-group" style={{position:'relative'}}>
        <label htmlFor="address">Default Address <span style={{color:'#aaa', fontWeight:400}}>(optional)</span></label>
        <input
          id="address"
          value={address}
          onChange={handleAddressChange}
          placeholder="Address (you can add this later)"
          autoComplete="off"
        />
        {addressLoading && <div style={{color:'#aaa', fontSize:'0.95em'}}>Loading...</div>}
        {addressSuggestions.length > 0 && (
          <ul style={{
            position: 'absolute',
            left: 0,
            right: 0,
            background: '#23272f',
            border: '1px solid #444',
            borderRadius: 6,
            zIndex: 10,
            listStyle: 'none',
            margin: 0,
            padding: 0,
            maxHeight: 180,
            overflowY: 'auto',
          }}>
            {addressSuggestions.map((s, i) => (
              <li
                key={i}
                style={{padding: '8px 12px', cursor: 'pointer'}}
                onClick={() => handleAddressSelect(s)}
                onMouseDown={e => e.preventDefault()}
              >
                {s}
              </li>
            ))}
          </ul>
        )}
        <div style={{fontSize:'0.95em', color:'#aaa', marginTop:4}}>You can add this later</div>
      </div>
      <div className="form-group">
        <label htmlFor="address2">Address Line 2 <span style={{color:'#aaa', fontWeight:400}}>(optional)</span></label>
        <input
          id="address2"
          value={address2}
          onChange={e => setAddress2(e.target.value)}
          placeholder="Apt, suite, unit, building, floor, etc. (optional)"
        />
      </div>
      <div className="form-group">
        <label htmlFor="phone">Phone Number <span style={{color:'#aaa', fontWeight:400}}>(optional)</span></label>
        <input id="phone" value={phone} onChange={e => setPhone(e.target.value)} placeholder="Phone (you can add this later)" />
        <div style={{fontSize:'0.95em', color:'#aaa', marginTop:4}}>You can add this later</div>
      </div>
      <div className="form-group">
        <label htmlFor="deliveryInstructions">Delivery Instructions <span style={{color:'#aaa', fontWeight:400}}>(optional)</span></label>
        <textarea
          id="deliveryInstructions"
          value={deliveryInstructions}
          onChange={e => setDeliveryInstructions(e.target.value)}
          placeholder="e.g. Gate code, leave at door, call on arrival, etc. (optional)"
          rows={2}
          style={{resize: 'vertical'}}
        />
      </div>
      <button onClick={handleSignUp} style={{ background: 'transparent', border: '1px solid #fff' }}>Sign Up</button>
      <div className="message">{message}</div>
      <div style={{marginTop: 18, textAlign: 'center'}}>
        Already have an account? <Link to="/signin" style={{ color: '#fff' }}>Sign in</Link>
      </div>
    </div>
  );
} 